import _ from 'underscore';

const displayType = 'Display';
// MT pass the integer value of this enum, so UI needs to hold a mapping.
const gSyncAdvertisingChannelType = ['Unknown', 'Search', displayType, 'Shopping', 'Video', 'MultiChannel', 'Smart', 'PerformanceMax', 'Discovery', 'DemandGen'];

export const getLocalizedCampaignTypeStringUtil = (type, i18n) => i18n.get(`CampaignImport_EntityType${type}`);

export const containDisplayTypeUtil = (campaignList, i18n) => {
  const localizedDisplayTypeString = getLocalizedCampaignTypeStringUtil(displayType, i18n);
  return _.some(campaignList, campaign =>
    ((campaign.Type || campaign.type) === localizedDisplayTypeString));
};

export const filterAndLocalizeCampaignsUtil = (campaigns, i18n, onError) => {
  const filteredAndLocalized = _.chain(campaigns)
    .filter((campaign) => {
      const status = campaign.Status;

      return status !== 'Draft' && status !== 'Delete' && status !== 'Deleted';
    })
    .map(({
      Id,
      Name,
      Type,
      Status,
      MerchantId = null,
    }) => {
      const convertedTypeAsString = gSyncAdvertisingChannelType[Type];

      if (!convertedTypeAsString) {
        onError(`unexpected campaign type ${Type}`);
      }
      return {
        Id,
        Name,
        Status,
        TypeId: Type,
        Type: getLocalizedCampaignTypeStringUtil(convertedTypeAsString, i18n),
        MerchantId,
      };
    })
    .value();

  return filteredAndLocalized;
};
